var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated && _vm.timeLeft > 0)?_c('div',{staticClass:"session-timer",attrs:{"title":"Click to refresh session"},on:{"click":_vm.resetTimer}},[_c('i',{staticClass:"fa fa-clock-o"}),_c('span',{staticClass:"timer-text",class:{ 'warning': _vm.showWarning }},[_vm._v(_vm._s(_vm.formatTime(_vm.timeLeft)))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }